import { useState, useEffect } from "react";
import { useSignal } from "@preact/signals-react";
import ModalForm from "components/Modals/ModalForm";
import Loading from "components/Tools/Loading";
import EmptyZone from "./EmptyZone";
import { cn } from "tools/ui";
import mainStore from "store/mainStore";
import childStore from "store/childStore";

function GridCardsNew(props) {
  const { data, attrs, field, isLoading = false } = props;
  const { ctxView, style } = field;
  const { level: _level } = attrs;
  const CustomCard = ctxView.card;
  const [selectedCard, setSelectedCard] = useState(null);

  const openModal = useSignal(false);

  let records = [];
  if (data.value) {
    records = Array.from(data.value.values());
  } else {
    // Is array
    records = data;
  }

  let level = _level;
  if (_level === "child") {
    level = "grand";
  } else if (_level === "main") {
    level = "child";
  }

  function onClose() {
    openModal.value = false;
  }

  function onClick(record) {
    const { setRecord: setMainRecord } = mainStore.getState();
    const {
      setRecord,
      // record: recordChild,
      // newRecord: newChild,
      // updateRecord: updateChildRecord,
      // updateStore: updateChildStore,
    } = childStore.getState();

    if (record.id > 0) {
      if (level === "main") {
        setMainRecord(record.id, ctxView.model, ctxView);
      } else if (level === "child") {
        setRecord(record.id, ctxView.model, ctxView);
      } else {
        console.log("Add code for grandchild here......");
      }
    } else {
      setSelectedCard(record);
    }
    openModal.value = true;
  }

  if (isLoading) return <Loading />;

  function cards(filtered = []) {
    if (!Array.isArray(filtered)) return null;

    return filtered.map((rec, idx) => (
      <CustomCard key={idx} record={rec} ctxView={ctxView} onClick={onClick} />
    ));
  }

  if (records.length === 0) {
    return <EmptyZone model={ctxView.model} />;
  }

  return (
    <div className={cn("col-span-2")}>
      <div
        id="grid-cards-new"
        className={cn("flex flex-wrap gap-y-3 gap-x-2 my-3", style)}
      >
        {cards(records)}
      </div>
      {openModal.value && (
        <ModalForm
          open={openModal.value}
          ctxView={ctxView}
          onClose={onClose}
          level={level}
          fieldName={field.name}
        />
      )}
    </div>
  );
}

export default GridCardsNew;
